<template>
    <div>
        <!-- 页面固定头部 -->
        <a-anchor :getContainer="getModuleContainer" style="width:100%">
            <!-- 面包屑组件 -->
            <FGBreadHead></FGBreadHead>
        </a-anchor>
        <a-page-header class="fun-panel" title="注销申请" :sub-title="subTitle" @back="onBack">
            <template v-slot:extra>
                <a-button :loading="loading || saving" type="primary" @click="onSave(0)">保存</a-button>
                <a-button :loading="loading || saving" type="primary" @click="onSave(1)">提交</a-button>
            </template>
            <a-divider></a-divider>
            <a-layout>
                <a-layout-content>
                    <a-spin :spinning="loading">
                        <a-form ref="form" class="fun-edit-form" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
                            <FGCollapsiblePanel title="基本信息">
                                <a-row :gutter="[0, 6]">
                                    <a-col :span="12">
                                        <a-form-item label="申请表编号">
                                            <a-input ref="zxsqbbh" v-model="editData.zxsqbbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注销日期" required>
                                            <a-date-picker ref="zxrq" v-model="editData.zxrq" width="100%" valueFormat="YYYY-MM-DD" style="width:100%" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位类别">
                                            <FGDictSelectCN ref="dwlb" dictNo="DW100102" v-model="editData.dwlb" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位编号">
                                            <a-input ref="dwbh" v-model="editData.dwbh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位名称">
                                            <a-input ref="dwmc" v-model="editData.dwmc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位类型">
                                            <a-input ref="dwlx" v-model="editData.dwlx" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="资信等级">
                                            <a-input ref="zxdj" v-model="editData.zxdj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="区域编号">
                                            <a-input ref="qybh" v-model="editData.qybh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="区域名称">
                                            <a-input ref="qymc" v-model="editData.qymc" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册地址">
                                            <a-input ref="zcdz" v-model="editData.zcdz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="办公地址">
                                            <a-input ref="bgdz" v-model="editData.bgdz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="邮政编码">
                                            <a-input ref="yzbm" v-model="editData.yzbm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="行业分类">
                                            <a-input ref="hyfl" v-model="editData.hyfl" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册资金(万元)">
                                            <a-input-number ref="zczj" v-model="editData.zczj" :precision="6" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="法人代表">
                                            <a-input ref="frdb" v-model="editData.frdb" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="法人固定电话">
                                            <a-input ref="frgddh" v-model="editData.frgddh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="法人移动电话">
                                            <a-input ref="fryddh" v-model="editData.fryddh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="联系人">
                                            <a-input ref="lxr" v-model="editData.lxr" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="联系人部门">
                                            <a-input ref="lxrbm" v-model="editData.lxrbm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="联系人职务">
                                            <a-input ref="lxrzw" v-model="editData.lxrzw" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="固定电话">
                                            <a-input ref="gddh" v-model="editData.gddh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="移动电话">
                                            <a-input ref="yddh" v-model="editData.yddh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="传真">
                                            <a-input ref="cz" v-model="editData.cz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="电子邮箱">
                                            <a-input ref="dzyx" v-model="editData.dzyx" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="网址">
                                            <a-input ref="wz" v-model="editData.wz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位性质">
                                            <a-input ref="dwxz" v-model="editData.dwxz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="职工总人数">
                                            <a-input-number ref="zgzrs" v-model="editData.zgzrs" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="专业技术人员数">
                                            <a-input-number ref="zyjsrs" v-model="editData.zyjsrs" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="专职从事工程咨询人数">
                                            <a-input-number ref="zzcszxrs" v-model="editData.zzcszxrs" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册咨询师人数">
                                            <a-input-number ref="zczxsrs" v-model="editData.zczxsrs" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="高级职称人数">
                                            <a-input-number ref="gjzcrs" v-model="editData.gjzcrs" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="中级职称人数">
                                            <a-input-number ref="zjzcrs" v-model="editData.zjzcrs" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="初级职称人数">
                                            <a-input-number ref="cjzcrs" v-model="editData.cjzcrs" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="博士人数">
                                            <a-input-number ref="bsrs" v-model="editData.bsrs" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="硕士人数">
                                            <a-input-number ref="ssrs" v-model="editData.ssrs" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="本科人数">
                                            <a-input-number ref="bkrs" v-model="editData.bkrs" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="办公面积(平方)">
                                            <a-input-number ref="bgmj" v-model="editData.bgmj" :precision="2" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="其中自有面积(平方)">
                                            <a-input-number ref="zymj" v-model="editData.zymj" :precision="2" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="计算机台数">
                                            <a-input-number ref="jsjts" v-model="editData.jsjts" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="质量体系认证">
                                            <a-input ref="zltxrz" v-model="editData.zltxrz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="认证日期">
                                            <a-input ref="rzrq" v-model="editData.rzrq" valueFormat="YYYY-MM-DD" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="认证机构">
                                            <a-input ref="rzjg" v-model="editData.rzjg" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="会费缴纳标准(元/年)">
                                            <a-input-number ref="hfjnbz" v-model="editData.hfjnbz" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="信息/通讯员">
                                            <a-input ref="xxyxm" v-model="editData.xxyxm" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="信息/通讯员电话">
                                            <a-input ref="xxydh" v-model="editData.xxydh" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="年检结论">
                                            <a-input ref="njjl" v-model="editData.njjl" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="质量检查结论">
                                            <FGDictSelect dictNo="DW100105" v-model="editData.jcjl" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="单位状态">
                                            <a-input ref="dwzt" v-model="editData.dwzt" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="注册时间">
                                            <a-input ref="zcsj" v-model="editData.zcsj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="入会时间">
                                            <a-input ref="rhsj" v-model="editData.rhsj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="12">
                                        <a-form-item label="退会时间">
                                            <a-input ref="thsj" v-model="editData.thsj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="单位简介" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                                            <a-textarea ref="dwjj" :rows="3" v-model="editData.dwjj" disabled />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="注销原因" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                                            <a-textarea ref="zxyy" :rows="3" v-model="editData.zxyy" />
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="24">
                                        <a-form-item label="备注" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                                            <a-textarea ref="bz" :rows="3" v-model="editData.bz" />
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                            </FGCollapsiblePanel>
                        </a-form>
                        <!-- 其他资质证书明细表格 -->
                        <FGCollapsiblePanel title="其他资质证书">
                            <vxe-table
                                ref="QTZZZSitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataQTZZZS"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                                <vxe-table-column field="zsmc" title="证书名称" width="200" sortable></vxe-table-column>
                                <vxe-table-column field="zsbh" title="证书编号" width="150"></vxe-table-column>
                                <vxe-table-column field="zymc" title="专业名称" width="150"></vxe-table-column>
                                <vxe-table-column field="zzdj" title="资质等级" width="120"></vxe-table-column>
                                <vxe-table-column field="zsrq" title="证书日期" width="120">
                                    <template v-slot="{ row }">
                                        <span> {{ $FG_util.formatDate(row.zsrq, "YYYY-MM-DD") }} </span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="zzyxq" title="资质有效期(年)" width="150"></vxe-table-column>
                                <vxe-table-column field="zsdqrq" title="证书到期日期" width="150">
                                    <template v-slot="{ row }">
                                        <span> {{ $FG_util.formatDate(row.zsdqrq, "YYYY-MM-DD") }} </span>
                                    </template>
                                </vxe-table-column>
                                <vxe-table-column field="bz" title="备注" min-width="200"></vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                        <!-- 分支机构明细表格 -->
                        <FGCollapsiblePanel title="分支机构">
                            <vxe-table
                                ref="FZJGitemTable"
                                size="mini"
                                resizable
                                keep-source
                                auto-resize
                                row-id="id"
                                align="left"
                                header-align="center"
                                highlight-hover-row
                                highlight-current-row
                                show-overflow="tooltip"
                                :data="editItemDataFZJG"
                                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
                            >
                                <vxe-table-column type="seq" title="序号" width="70" align="center"></vxe-table-column>
                                <vxe-table-column field="jgmc" title="机构名称" width="200" sortable></vxe-table-column>
                                <vxe-table-column field="xxdz" title="详细地址" width="200"></vxe-table-column>
                                <vxe-table-column field="yzbm" title="邮政编码" width="150"></vxe-table-column>
                                <vxe-table-column field="dzyx" title="电子邮箱" width="150"></vxe-table-column>
                                <vxe-table-column field="fzr" title="负责人" width="120"></vxe-table-column>
                                <vxe-table-column field="fzrdh" title="负责人电话" width="150"></vxe-table-column>
                                <vxe-table-column field="bz" title="备注" min-width="200"></vxe-table-column>
                            </vxe-table>
                        </FGCollapsiblePanel>
                    </a-spin>
                </a-layout-content>
                <a-layout-sider class="region-attach-uploadpanel">
                    <AttachUpload :isnew="isnew" :attachCfg.sync="attachCfg" />
                </a-layout-sider>
            </a-layout>
        </a-page-header>
    </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters: userMapGetters } = createNamespacedHelpers("user");
export default {
    name: "ZxdjEdit",
    props: ["showEdit", "dataId"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 主表数据
            editData: {},
            editDataLoading: false,
            //资质证书及服务范围
            editItemDataZZZS: [],
            editItemDataZZZSLoading: false,
            //其它资质证书
            editItemDataQTZZZS: [],
            editItemDataQTZZZSLoading: false,
            //分支机构
            editItemDataFZJG: [],
            editItemDataFZJGLoading: false,
            //项目成果获奖情况
            editItemDataXMCG: [],
            editItemDataXMCGLoading: false,
            //单位通讯员
            editItemDataLXR: [],
            editItemDataLXRLoading: false,
            isnew: true,
            attachCfg: {},
            attachtype: "upload",
            isShowIcon: true
        };
    },
    computed: {
        ...userMapGetters(["getUserInfo", "getToken"]),
        subTitle() {
            return this.dataId ? "编辑" : "新增";
        },
        // 是否显示编辑界面
        editIsVisible: {
            get() {
                return this.showEdit;
            },
            set(newVal) {
                this.$emit("update:showEdit", newVal);
            }
        },
        // 当前编辑记录id
        editDataId: {
            get() {
                return this.dataId;
            },
            set(newVal) {
                this.$emit("update:dataId", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        }
    },
    activated() {
        if (!this.editDataId) {
            this.$FG_http
                .post(
                    "./api/main/dwzx/dwzxgl/selectDwxxByYhid",
                    {
                        yhid: this.getUserInfo.id
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 新增，设置默认值
                            this.editData = {
                                id: this.$FG_util.uuid(),
                                isnew: true,
                                djlxid: "ZXSQB",
                                zxsqbbh: "",
                                zxrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD"),
                                dwlb: data.data.dwlb,
                                dwid: data.data.id,
                                dwbh: data.data.dwbh,
                                dwmc: data.data.dwmc,
                                dwlx: data.data.dwlx,
                                zxdj: data.data.zxdj,
                                qyid: data.data.qyid,
                                qybh: data.data.qybh,
                                qymc: data.data.qymc,
                                zcdz: data.data.zcdz,
                                bgdz: data.data.bgdz,
                                yzbm: data.data.yzbm,
                                hyfl: data.data.hyfl,
                                zczj: data.data.zczj,
                                frdb: data.data.frdb,
                                frgddh: data.data.frgddh,
                                fryddh: data.data.fryddh,
                                lxr: data.data.lxr,
                                lxrbm: data.data.lxrbm,
                                lxrzw: data.data.lxrzw,
                                gddh: data.data.gddh,
                                yddh: data.data.yddh,
                                cz: data.data.cz,
                                dzyx: data.data.dzyx,
                                wz: data.data.wz,
                                dwxz: data.data.dwxz,
                                zgzrs: data.data.zgzrs,
                                zyjsrs: data.data.zyjsrs,
                                zzcszxrs: data.data.zzcszxrs,
                                zczxsrs: data.data.zczxsrs,
                                gjzcrs: data.data.gjzcrs,
                                zjzcrs: data.data.zjzcrs,
                                cjzcrs: data.data.cjzcrs,
                                bsrs: data.data.bsrs,
                                ssrs: data.data.ssrs,
                                bkrs: data.data.bkrs,
                                bgmj: data.data.bgmj,
                                zymj: data.data.zymj,
                                jsjts: data.data.jsjts,
                                zltxrz: data.data.zltxrz,
                                rzrq: data.data.rzrq,
                                rzjg: data.data.rzjg,
                                dwjj: data.data.dwjj,
                                hfjnbz: data.data.hfjnbz,
                                xxyxm: data.data.xxyxm,
                                xxydh: data.data.xxydh,
                                njjl: data.data.njjl,
                                jcjl: data.data.jcjl,
                                dwzt: data.data.dwzt,
                                zcsj: data.data.zcsj,
                                rhsj: data.data.rhsj,
                                thsj: data.data.thsj,
                                bmid: this.getUserInfo.org_id,
                                yhid: this.getUserInfo.id,
                                ryid: this.getUserInfo.personnel_id,
                                lrbmmc: this.getUserInfo.org_name,
                                lrrxm: this.getUserInfo.personnel_name,
                                lrrq: this.$FG_util.formatDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
                                djzt: "制定"
                            };
                            this.$FG_helper.handleNewBillCode("ZXSQBBH").then((val) => {
                                this.editData.zxsqbbh = val;
                            });
                            this.loadItemDataQTZZZS();
                            this.loadItemDataFZJG();
                            //附件数据
                            this.isnew = true;
                            this.attachCfg = {
                                fktable: "DW_DWZXSQB",
                                fkfield: "ID",
                                fkvalue: this.editData.id,
                                attachsource: "DWZX01"
                            };
                        } else {
                            // 加载的数据不存在则提示错误并关闭编辑窗口
                            this.$FG_message.error("P0002").then(() => (this.editIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则关闭弹窗
                        this.editIsVisible = false;
                    }
                });
        } else {
            // 修改，加载数据
            this.loadData();
            //附件数据
            this.isnew = false;
            this.attachCfg = {
                fktable: "DW_DWZXSQB",
                fkfield: "ID",
                fkvalue: this.dataId,
                attachsource: "DWZX01"
            };
        }
    },
    methods: {
        confirm() {
            this.editData.qrrxm = this.getUserInfo.personnel_name;
            this.$FG_http
                .post("./api/main/dwzx/dwzxgl/confirm", {
                    id: this.editData.id,
                    qrrid: this.getUserInfo.id
                })
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        // 返回列表
                        this.onBack();
                    } else {
                        this.$refs.zxrq.focus();
                    }
                });
        },
        unConfirm() {
            this.$FG_http
                .post("./api/main/dwzx/dwzxgl/unConfirm", {
                    id: this.editData.id
                })
                .then(({ success, data, errMsg }) => {
                    this.tableDataLoading = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        // 返回列表
                        this.onBack();
                    } else {
                        this.$refs.zxrq.focus();
                    }
                });
        },
        //提交form
        onSave(btnType) {
            if (btnType === 1) {
                // 表单校验 return;
                if (!this.editData.zxrq) {
                    this.$FG_message.error("P0001", "注销日期").then(() => this.$refs.zxrq.focus());
                    return;
                }
            }
            // 保存操作

            this.saving = true;
            this.$FG_http
                .post(
                    "./api/main/dwzx/dwzxgl/save",
                    {
                        data: this.editData
                    },
                    {
                        showSuccess: btnType === 1 ? false : true
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.saving = false;
                    if (success) {
                        // 设置当前行
                        this.editDataId = this.editData.id;
                        this.editData.isnew = false;
                        // 返回列表
                        this.isnew = false;
                    } else {
                        this.$refs.zxrq.focus();
                    }
                })
                .then(() => {
                    if (this.editDataId) {
                        if (btnType === 1) {
                            this.submit();
                        }
                    }
                });
        },
        //提交
        submit(type) {
            this.$FG_message.confirm("P0000", "提交").then((type) => {
                if (type === "ok") {
                    this.$FG_http
                        .post("./api/main/dwzx/dwzxgl/submit", {
                            id: this.editData.id
                        })
                        .then(({ success, data, errMsg }) => {
                            this.tableDataLoading = false;
                            if (success) {
                                // 设置当前行
                                this.editDataId = this.editData.id;
                                // 返回列表
                                this.onBack();
                            } else {
                                this.$refs.zxrq.focus();
                            }
                        });
                }
            });
        },
        loadData() {
            this.editData = {};
            this.editDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwzx/dwzxgl/selectById",
                    {
                        id: this.dataId
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editDataLoading = false;
                    if (success) {
                        if (data.data) {
                            // 设置当前编辑数据
                            this.editData = data.data;
                            // 加载明细数据
                            this.loadItemDataQTZZZS();
                            this.loadItemDataFZJG();
                        } else {
                            // 加载的数据不存在则提示错误并返回列表
                            this.$FG_message.error("P0002").then(() => (this.insertIsVisible = false));
                        }
                    } else {
                        // 加载数据出错或没有加载到数据则返回列表
                        this.insertIsVisible = false;
                    }
                });
        },
        // 加载明细表数据
        loadItemDataZZZS() {
            this.editItemDataZZZS = [];
            this.editItemDataZZZSLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwzx/dwzxgl/listItemQTZZZS",
                    {
                        dwid: this.editData.dwid,
                        sort: {
                            field: "zsbh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataZZZSLoading = false;
                    if (success) {
                        this.editItemDataZZZS = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onBack();
                    }
                });
        },
        loadItemDataQTZZZS() {
            this.editItemDataQTZZZS = [];
            this.editItemDataQTZZZSLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwzx/dwzxgl/listItemQTZZZS",
                    {
                        dwid: this.editData.dwid,
                        sort: {
                            field: "zsbh",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataQTZZZSLoading = false;
                    if (success) {
                        this.editItemDataQTZZZS = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onBack();
                    }
                });
        },
        // 加载明细表数据
        loadItemDataFZJG() {
            this.editItemDataFZJG = [];
            this.editItemDataFZJGLoading = true;
            this.$FG_http
                .post(
                    "./api/main/dwzx/dwzxgl/listItemFZJG",
                    {
                        dwid: this.editData.dwid,
                        sort: {
                            field: "jgmc",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataFZJGLoading = false;
                    if (success) {
                        this.editItemDataFZJG = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.onBack();
                    }
                });
        },
        // 返回列表
        onBack() {
            this.editIsVisible = false;
        }
    }
};
</script>
